import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Search } from "lucide-react";

export default function TrackCTA() {
  const navigate = useNavigate();
  const [ticket, setTicket] = useState("");
  const [email, setEmail] = useState("");

  const go = (e) => {
    e.preventDefault();
    navigate(`/track?ticket=${encodeURIComponent(ticket.trim())}&email=${encodeURIComponent(email.trim())}`);
  };

  return (
    <section id="track" className="border-y border-[#DCD3C3] bg-[#EAE2D5]" data-testid="track-cta-section">
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-20 grid lg:grid-cols-2 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#B38728] flex items-center gap-3">
            <span className="inline-block w-10 h-px bg-[#B38728]" /> 05 — Offer Tracker
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight mt-4">
            Already negotiating <span className="italic gold-text">with the vault?</span>
          </h2>
          <p className="text-[#5C564C] text-sm md:text-base leading-relaxed mt-4 max-w-md">
            Every offer and valuation carries a reference number (check your emails — it looks like SX-0001).
            Pop it in with your email to see exactly where your deal stands, and accept, decline or counter without a single email chain.
          </p>
        </motion.div>
        <motion.form
          onSubmit={go}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.12, ease: [0.16, 1, 0.3, 1] }}
          className="bg-white border border-[#DCD3C3] p-6 sm:p-8"
          data-testid="track-cta-form"
        >
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#5C564C]">Reference Number</label>
              <input
                required
                value={ticket}
                onChange={(e) => setTicket(e.target.value)}
                data-testid="track-cta-ticket-input"
                placeholder="SX-0001"
                className="mt-2 w-full bg-[#F3EDE3] border border-[#DCD3C3] px-4 py-3 text-sm focus:outline-none focus:border-[#B38728] transition-colors"
              />
            </div>
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#5C564C]">Email</label>
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="track-cta-email-input"
                placeholder="The email you submitted with"
                className="mt-2 w-full bg-[#F3EDE3] border border-[#DCD3C3] px-4 py-3 text-sm focus:outline-none focus:border-[#B38728] transition-colors"
              />
            </div>
          </div>
          <button
            type="submit"
            data-testid="track-cta-submit-button"
            className="mt-5 w-full bg-[#0A0A0A] text-[#F3EDE3] py-4 font-mono text-xs uppercase tracking-[0.3em] hover:bg-[#B38728] hover:text-[#0A0A0A] transition-colors flex items-center justify-center gap-3"
          >
            <Search className="w-4 h-4" /> Track My Offer
          </button>
        </motion.form>
      </div>
    </section>
  );
}
